/**
 * SearchWordDetailContainer
 * --
 */
import React from 'react';
import SearchWordDetailPresenter from './SearchWordDetailPresenter';

const SearchWordDetailContainer = () => {
  /* ===== ROUTE ===== */
  /* ===== PROPS ===== */
  /* ===== STATE ===== */
  /* ===== VARIABLE ===== */
  /* ===== FUNCTION ===== */
  /* ===== HOOKS ===== */
  /* ===== RENDER ===== */
  return (
    <>
      <SearchWordDetailPresenter />
    </>
  );
};

export default SearchWordDetailContainer;
